/** @jsx jsx */
import { Button, FacebookIcon, Flex, Heading, Inline, InstagramIcon, LinkedinIcon, TwitterIcon } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { ResponsiveCard } from "@/components/ResponsiveCard";
import { PublicProfile } from "@/data/public-profiles";

export interface ISocialSectionProps {
  publicProfile: PublicProfile;
}

export const SocialSection: FC<ISocialSectionProps> = ({ publicProfile }) => {
  const { t } = useTranslation("public");

  const showCard =
    publicProfile.facebookSlug ||
    publicProfile.twitterSlug ||
    publicProfile.linkedinSlug ||
    publicProfile.instagramSlug;

  if (!showCard) {
    return null;
  }

  return (
    <ResponsiveCard sx={{ py: ["sm", "sm", "sm", "sm"] }}>
      <Flex alignItems="center" justifyContent="space-between">
        <Heading size="h-xs" color="n700">
          {t("CLIENT_PAGE.DETAILS.SOCIAL.HEADER")}
        </Heading>

        <Inline>
          {publicProfile.twitterSlug && (
            <Button
              as="a"
              href={`https://twitter.com/${publicProfile.twitterSlug}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="ghost"
              iconLeft={<TwitterIcon />}
            />
          )}
          {publicProfile.facebookSlug && (
            <Button
              as="a"
              href={`https://facebook.com/${publicProfile.facebookSlug}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="ghost"
              iconLeft={<FacebookIcon />}
            />
          )}
          {publicProfile.linkedinSlug && (
            <Button
              as="a"
              href={`https://linkedin.com/company/${publicProfile.linkedinSlug}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="ghost"
              iconLeft={<LinkedinIcon />}
            />
          )}
          {publicProfile.instagramSlug && (
            <Button
              as="a"
              href={`https://instagram.com/${publicProfile.instagramSlug}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="ghost"
              iconLeft={<InstagramIcon />}
            />
          )}
        </Inline>
      </Flex>
    </ResponsiveCard>
  );
};
